import React, { ReactNode, useEffect, useRef } from "react";

export interface FaqCollapsibleProps {
  item: FaqItem;
}

export interface FaqItem {
  title: string;
  content: ReactNode;
}

export const FaqCollapsible: React.FunctionComponent<FaqCollapsibleProps> = (props: FaqCollapsibleProps) => {
  const [active, setActive] = React.useState(false);
  const contentRef = useRef(null);
  useEffect(() => {
    contentRef.current.style.maxHeight = active ? `${contentRef.current.scrollHeight}px` : "0px";
  }, [contentRef, active]);

  const toggleAccordion = (): void => {
    setActive(!active);
  };
  return (
    <div className="mt-3">
      <div className={`cursor-pointer faq ${active}`} onClick={toggleAccordion}>
        <div className="leader d-flex justify-content-between">
          <div className="title ">{props.item.title}</div>
          <div>{active ? <>-</> : <>+</>}</div>
        </div>

        <div ref={contentRef} className={"content mb-3"}>
          {props.item.content}
        </div>
      </div>
    </div>
  );
};
